import { createAsyncThunk } from '@reduxjs/toolkit';
import { getProjectDefectListsData } from 'scenes/DefectList/services/get-project-defect-lists-data.service';
import { selectSelectedProjectId } from 'store/projects/selectors/projectsSelectors';

/**
 * Read one project's defect lists into the store.
 *
 * The argument is optional and defaults to the project the user is on, which is
 * what every scene wants — they load the data for the view they are opening.
 * Nerobotti passes one explicitly: its writes name a project, the panel outlives
 * any scene, and a background refetch that read whichever project happened to be
 * selected would refresh the wrong data or none.
 *
 * Loading a project the user is not looking at is safe here because the store is
 * flat and the selectors are not — every list, item and image selector filters
 * on the selected project — so the rows simply wait until they are the ones
 * being shown.
 */
export const loadProjectDefectListsData = createAsyncThunk(
  'defectLists/loadProjectDefectListsData',
  async (projectId, { getState }) => {
    const targetProjectId = projectId ?? selectSelectedProjectId(getState());
    const defectListsData = await getProjectDefectListsData(targetProjectId);

    return defectListsData;
  }
);
